<template>
  <b-container>
    <Breadcrumbs crumbString="What We Do,Historical"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>
          enviroSIGNS has provided historical signs and markers throughout the country.
        </div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <b-container class="pods-container">
          <b-row>
            <b-col class="col-12 col-md-8 col-md-8 image-pod">
              <div class="img historical-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/historical/historical-sign-imageLOC.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-4 col-md-4 image-pod">
              <div class="img historical-164-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/historical/historical-sign-etched.jpg') + ')'}"></div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-5 col-md-5 image-pod">
              <div class="img historical-168-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/historical/historical-marker-novalloy.jpg') + ')'}"></div>
            </b-col>
            <b-col>
              <b-row>
                <b-col class="col-12 image-pod">
                  <div class="img historical-60-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/historical/histrocial-sign-novalloy.jpg') + ')'}"></div>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="col-12 image-pod">
                  <div class="img historical-55-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/historical/historical-marker-custom-high-pressure-laminate.jpg') + ')'}"></div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'

  export default {
    components: {
      Breadcrumbs
    },

    data () {
      return {
        title: 'Historical'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/whatWeDo/Historical.vue